import { render } from "./TDCar.vue?vue&type=template&id=83737250"
import script from "./TDCar.vue?vue&type=script&lang=js"
export * from "./TDCar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__